export enum ListStyle {
  Disc = 'disc',
  Decimal = 'decimal',
}
